module.exports = __webpack_public_path__ + "static/img/46.69e88da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/46.jpg
// module id = E4QK
// module chunks = 3